<template>
  <div class="table_block">
    <!-- <Row ref="dataTable"> -->
      <Table
        :loading="loading"
        border
        width='100%'
        stripe :columns="columns"
        :data="table.data"
        size="small"
        :height="tableHeight"
        ref="dataTableList"
        disabled-hover
        highlight-row
        @on-selection-change="selectionChange"
        @on-row-click="onRowClick"
      ></Table>
      <div v-if="pageShow" class="mt-2 page_out">
        <Page
          :total="pagination.total"
          :page-size-opts="pagination.sizes"
          :current="pagination.search.PageIndex"
          :page-size="pagination.search.PageSize"
          show-elevator
          show-sizer
          show-total
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
        />
         <!-- <Page :total="100"></Page> -->
      </div>

      <RouterModel ref="routerModal"></RouterModel>
    <!-- </Row> -->
  </div>
</template>

<script>
import helper from "@/utils/helper.js";
import RouterModel from "@/components/RouterModal.vue";

export default {
  name: "NormalTable",
  components: { RouterModel },
  props: {
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    apiUrl: {
      type: [Number, String],
    },
    search: {
      type: Object,
    },
    // 是否开启table高度自适应
    heightAuto:{
      type: Boolean,
      default: true
    },
    reduceHeight:{
      type:Number,
      default:70
    },
    tableDataName:{
      type:String,
      default: 'list'
    },
    // 自定义table高度
    height:{
      type: [Number, String],
      default: 'auto'
    },
    requestType:{
      type: String,
      default: 'get'
    },
    pageShow: {
      type: Boolean,
      default: true
    },
  },
  data: function () {
    return {
      loading: false,
      table: {
        data: [],
        height: 0,
      },
      pagination: {
        total: 0,
        sizes: [10, 20, 30, 50],
        search: {
          PageIndex: 1,
          PageSize: 10,
        }
      },
      tableHeight:450
    };
  },
  activated: function () {
    if(this.heightAuto){
      let timeID = null
      const comHeight = () => {
        let height = window.innerHeight - this.$refs.dataTableList.$el.offsetTop - this.reduceHeight
        return height>200?height:200
      }
      this.tableHeight=comHeight()
      window.onresize = () => {
        clearTimeout(timeID)
        timeID = setTimeout(() => this.tableHeight=comHeight(), 500)
      }
    }
  },
  mounted(){
    this.tableHeight=this.height
  },
  created(){
    this.pagination.search.PageSize=this.search.PageSize||10
  },
  deactivated(){
    if(this.heightAuto){
      window.onresize = null
    }
  },
  methods: {
    //表格
    load: function () {
      //合并搜索条件
      this.loading = true;
      var temp = Object.assign({}, this.search, this.pagination.search); //合并对象
      if(this.requestType=='post'){
        temp.pageNumber=temp.PageIndex
        delete temp.PageIndex
      }
      // console.log('url',this.apiUrl);
      this.$api[this.requestType](this.apiUrl, temp).then((rsp) => {
        if (rsp != false) {
          if(this.requestType=='post'){
            this.$emit('getData', rsp.data)
            if (rsp.statusCode == 200 || rsp.result == 200){
              this.table.data = rsp.data[this.tableDataName];
              this.pagination.total = rsp.data.dataCount || rsp.data.total;
            }else{
              this.$emit('getData', [])
              this.table.data = []
            }
          }else{
            if (rsp.statusCode == 200 || rsp.result == 200){
              this.$emit('getData', rsp.data)
              this.table.data = rsp.data[this.tableDataName];
              this.pagination.total = rsp.data.total || rsp.data.dataCount;
            }else{
              this.$emit('getData', [])
              this.table.data = []
            }
          }
        } else {
          this.$emit('getData', false)
        }
      }).finally(()=>{
        this.loading = false;
      });
    },

    initload: function () {
      //合并搜索条件
      this.loading = true;
      this.table.data=[]
      this.pagination.search.PageIndex = 1;
      var temp = Object.assign({}, this.search, this.pagination.search);
      if(this.requestType=='post'){
        temp.pageNumber=temp.PageIndex
        delete temp.PageIndex
      }
      this.$api[this.requestType](this.apiUrl, temp).then((rsp) => {
        if (rsp != false) {
          if(this.requestType=='post'){
            console.log(rsp)
            if (rsp.statusCode == 200 || rsp.result == 200){
              this.$emit('getData', rsp.data)
              this.table.data = rsp.data[this.tableDataName];
              this.pagination.total = rsp.data.dataCount || rsp.data.total;
            }else{
              this.$emit('getData', [])
              this.table.data = []
            }
          }else{
            if (rsp.statusCode == 200 || rsp.result == 200){
              this.$emit('getData', rsp.data)
              this.table.data = rsp.data[this.tableDataName];
              this.pagination.total = rsp.data.total || rsp.data.dataCount;
            }else{
              this.$emit('getData', [])
              this.table.data = []
            }
          }
        } else {
          this.$emit('getData', false)
        }
      }).finally(()=>{
        this.loading = false;
      });
    },

    //分页
    pageChange: function (page) {
      this.pagination.search.PageIndex = page;
      this.load();
    },
    sizeChange: function (size) {
      console.log('sizeChange')
      this.pagination.search.PageSize = size;
      if(this.pagination.search.PageIndex==1){
        this.load();
      }else{
        this.pagination.search.PageIndex = 1;
      }
    },
    //模态框
    openModel: function (title, path) {
      this.$refs.routerModal.openModel(title, path);
    },
    closeModel: function () {
      this.$refs.routerModal.closeModel();
    },

    //多选框触发事件
    selectionChange: function (data) {
      this.$emit("selectionChange", data);
    },
    onRowClick: function (data) {
      this.$emit("onRowClick", data);
    },
  },
};
</script>
<style scoped>
  .table_block >>> .subCol>ul>li{
    margin:0 -18px;
    list-style:none;
    text-Align: center;
    padding-top: 14px;
    border-bottom:1px solid #e8eaec;
    overflow-x: hidden;
    min-height: 42px;
  }
  .table_block >>> .subCol>ul>li:last-child{
    border-bottom: none
  }
  .table_block{
    background: #fff;
    border-radius: 10px;
    padding: 15px;
  }
  .table_block >>> .tableTooltip .ivu-tooltip-rel{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100px;
  }
  .page_out{
    width: 100%;
    text-align: right;
  }
</style>
